export const json = {
   "surveyId": "9874f483-8d3b-4abd-b064-3eefaaeb8cbf",
   "surveyPostId": "aedcf66e-f9bf-43aa-be78-23f90c99de94"
}
